import { AlpineComponent } from '@alpinejs/csp';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const Navigation = (): AlpineComponent => ({
  value: '',
  timeout: null,
  openIndex: 0,
  isSubmenuOpen: false,

  init() {
    this.$refs.dialog.addEventListener('close', () => {
      (this.$store as any).general.isNavOpen = false;
    });
  },

  getClassName() {
    return {
      'navigation--is-open': this.$store.general.isNavOpen,
      'navigation--subnav-is-open': this.$store.general.isSubNavOpen
    };
  },

  openNav() {
    this.$store.general.openNav();
    this.openDialog();
  },

  closeNav() {
    this.$store.general.closeNav();
    const selected = this.$root.querySelectorAll('[aria-selected="true"]');
    [...selected].forEach((i) => i.setAttribute('aria-selected', 'false'));
    this.closeDialog();
  },

  isNavOpen() {
    return this.$store.general.isNavOpen;
  },

  openSubNav(e: any) {
    const selected = this.$root.querySelectorAll('[aria-selected="true"]');
    [...selected].forEach((i) => i.setAttribute('aria-selected', 'false'));

    const index = Number(e.currentTarget.getAttribute('data-index'));
    this.$store.general.openSubNav(index);

    const nextSelected = this.$root.querySelectorAll(`[data-index="${index}"]`);
    [...nextSelected].forEach((i) => i.setAttribute('aria-selected', 'true'));

    this.openDialog();
  },
  closeSubNav() {
    this.$store.general.closeSubNav();
    const selected = this.$root.querySelectorAll('[aria-selected="true"]');
    [...selected].forEach((i) => i.setAttribute('aria-selected', 'false'));
    this.closeDialog();
  },

  focusFirstLink() {
    const openSubNav = this.$refs.menu.querySelector('ul[aria-hidden="false"]');
    const firstLink = openSubNav?.querySelector('a');

    if (firstLink) firstLink.focus();
  },

  openDialog() {
    if (this.timeout) clearTimeout(this.timeout);
    disableBodyScroll(this.$refs.dialog);
    (this.$refs.dialog as HTMLDialogElement).showModal();

    this.focusFirstLink();
  },

  closeDialog() {
    enableBodyScroll(this.$refs.dialog);
    this.timeout = setTimeout(() => {
      (this.$refs.dialog as HTMLDialogElement).close();
    }, 300);
  },

  isHidden() {
    return (
      this.$store.general.openSubNavIndex !== Number(this.$el.dataset.index)
    );
  },
  isOpen() {
    return (
      this.$store.general.openSubNavIndex === Number(this.$el.dataset.index)
    );
  }
});

export default Navigation;
